import globals from '../globals'

export default function getZoomFromScaleDenom(scaleDenom) {
  const zoom = globals.BASE_SCALES.findIndex(function(scale) {
    return scaleDenom > scale
  })
  return zoom < 0 ? 20 : zoom
}

/*

import globals from '../globals'

export default function getZoomFromScaleDenom (scaleDenom) {
  const zoom = globals.BASE_SCALES.findIndex(function (scale) {
    return scaleDenom > scale
  })
  return zoom - 1
}

*/



// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/util/getZoomFromScaleDenom.js